<solution-display [showTitle]="false">
  <solution-display-item *ngFor="let solution of solutions; index as i"
      [title]="solution.Title" [titleTag]="solution.TypeTag" [index]="i">
    <solution [data]="solution"></solution>
  </solution-display-item>
</solution-display>
